import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { GrandOpening } from "src/app/core/services/myqq";
import { MyQQService } from "src/app/core/services/myqq/myqq.service";

export const grandOpeningDataResolver: ResolveFn<GrandOpening> = (
  route,
  state
) => {
  const myqq = inject(MyQQService);
  const storeNumber = route.params["storenumber"] as string;
  return myqq.getGrandOpeningByStoreNumber(storeNumber);
};

export const washToWinTitleResolver: ResolveFn<string> = (route) => {
  const { city } = route.parent.data["grandOpening"] as GrandOpening;
  return `Wash to Win (${city}) | Quick Quack Car Wash`;
};

export const freeDaysTitleResolver: ResolveFn<string> = (route, _state) => {
  const { city } = route.parent.data["grandOpening"] as GrandOpening;
  return `12 Days of Free (${city}) | Quick Quack Car Wash`;
};
